import React, { useEffect, useMemo, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import clsx from 'clsx';
import images from '../../Theming/images';

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
`;

const StyledImage = styled.img`
  position: fixed;
  animation: ${bounce} 2s infinite;

  &.showAtBottom {
    bottom: 4px;
    left: 30px;
  }

  &.showAtTop {
    top: 8px;
    left: 5px;
  }
`;

const TAP_HERE_IMAGES = {
  itv: {
    bottom: images.partnerpluginsdk_tap_here_bottom_itvx,
    top: images.partnerpluginsdk_tap_here_top_left_itvx,
  },
};

const TapHereAnimated: React.FC = () => {
  const sliide = false;
  const [showAtBottom, setShowBottom] = useState(true);
  const image = useMemo(() => {
    const imagesToShow = TAP_HERE_IMAGES.itv;

    return showAtBottom ? imagesToShow.bottom : imagesToShow.top;
  }, [showAtBottom, sliide]);

  function getiOSVersion() {
    const userAgent = navigator.userAgent || '';
    if (/iP(hone|od|ad)/.test(userAgent)) {
      const v = userAgent.match(/OS (\d+)_/);
      return v ? parseInt(v[1], 10) : null;
    }
    return null;
  }

  useEffect(() => {
    const version = getiOSVersion();

    if (version && version < 15) {
      setShowBottom(false);
    }
  }, []);

  return (
    <StyledImage
      className={clsx({ showAtBottom, showAtTop: !showAtBottom })}
      src={image}
    />
  );
};

export default TapHereAnimated;
